<template>
    <div>
        <div class="filtercontainer uk-flex uk-flex-center trucks">
            <div id="filter">
                <ul class="types uk-flex-center" uk-grid>
                    <li>
                        <a :class="{active: (selectedType === '0' || selectedType == '' || selectedType == 'all')}" href="#" @click.prevent="setSelect('')">
                            <ins class="icon all"></ins>
                            <span class="text">{{ translations.choices.All }}</span>
                            <span class="text">({{ countList.all }})</span>
                        </a>
                    </li>
                    <li v-if="countList.trekker">
                        <a :class="{active: selectedType === 'trekker'}" href="#" @click.prevent="setSelect('trekker')">
                            <ins class="icon trekker"></ins>
                            <span class="text">{{ translations.choices.Trekker }}</span>
                            <span class="text">({{ countList.trekker }})</span>
                        </a>
                    </li>
                    <li v-if="countList.oplegger">
                        <a :class="{active: selectedType === 'oplegger'}" href="#" @click.prevent="setSelect('oplegger')">
                            <ins class="icon oplegger"></ins>
                            <span class="text">{{ translations.choices.Oplegger }}</span>
                            <span class="text">({{ countList.oplegger }})</span>
                        </a>
                    </li>
                    <li v-if="countList.aanhanger">
                        <a :class="{active: selectedType === 'aanhanger'}" href="#" @click.prevent="setSelect('aanhanger')">
                            <ins class="icon aanhanger"></ins>
                            <span class="text">{{ translations.choices.Aanhanger }}</span>
                            <span class="text">({{ countList.aanhanger }})</span>
                        </a>
                    </li>
                    <li v-if="countList.vrachtwagen">
                        <a :class="{active: selectedType === 'vrachtwagen'}" href="#" @click.prevent="setSelect('vrachtwagen')">
                            <ins class="icon bakwagen"></ins>
                            <span class="text">{{ translations.choices.Vrachtwagen }}</span>
                            <span class="text">({{ countList.vrachtwagen }})</span>
                        </a>
                    </li>
                    <li v-if="countList.diversen">
                        <a :class="{active: selectedType === 'diversen'}" href="#" @click.prevent="setSelect('diversen', countList.diversen)">
                            <ins class="icon diversen"></ins>
                            <span class="text">{{ translations.choices.Diversen }}</span>
                            <span class="text">({{ countList.diversen }})</span>
                        </a>
                    </li>
                    <li v-if="countList.veetransport">
                        <a :class="{active: selectedType === 'veetransport'}" href="#" @click.prevent="setSelect('veetransport')">
                            <ins class="icon veewagen"></ins>
                            <span class="text">{{ translations.choices.Veetransport }}</span>
                            <span class="text">({{ countList.veetransport }})</span>
                        </a>
                    </li>
                    <li>
                        <a :class="{active: selectedType === 'expected'}" href="#" @click.prevent="setSelect('expected')">
                            <ins class="icon verwacht"></ins>
                            <span class="text uk-text-uppercase">{{ translations.choices.Expected }}</span>
                            <span class="text">({{ countList.verwacht ? countList.verwacht : 0 }})</span>
                        </a>
                    </li>
                </ul>

                <div class="uk-flex-center uk-grid-small" uk-grid>
                    <div class="uk-width-2-5@m">
                        <input class="text-field" :placeholder="translations.placeholder" v-model="term" @keyup.enter="changeFilter()"/>
                    </div>
                    <div class="uk-width-1-5@m">
                        <input class="button blue" type="submit" :value="translations.Zoeken" @click.prevent="changeFilter()"/>
                    </div>
                    <div class="uk-width-1-3@m" v-if="selectedType || term">
                        <input class="button blue" type="submit" :value="translations.Toon_alles" @click.prevent="resetFilter()"/>
                    </div>
                </div>
            </div>
        </div>

        <h2 class="no-results" v-if="showh2">{{ translations.Geen_resultaat }}</h2>
        <!--<h2 class="no-results" v-if="favorites != ''">{{ translations.Favorieten }}</h2>-->

        <ul id="stocklist" class="uk-grid-match uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid>
            <stock-item
                v-for="item in list"
                :id="item.id"
                :merk="item.merk"
                :model="item.model"
                :type="item.type"
                :voertuignr_klant="item.voertuignr_klant"
                :tellerstand="item.tellerstand"
                :vermogen_motor_pk="item.vermogen_motor_pk"
                :reg_year="item.reg_year"
                :subdirectory="subdirectory"
                :translations="translations"
                :slug="item.slug"
                :image="item.image"
                :video="item.video"
                :price="item.verkoopprijs_particulier"
                :key="item.id">
            </stock-item>
        </ul>
        <infinite-loading @infinite="onInfinite" ref="infiniteLoading" spinner="waveDots">
            <span slot="no-more"></span>
            <span slot="no-results"></span>
        </infinite-loading>
    </div>
</template>

<script>
    let blocks = `
       <li class="uk-width-1-1" id="blocks">
       <div class="blocks">
    <div class="uk-child-width-1-2@s uk-grid-match" uk-grid>
        <div><div class="block uk-height-1-1">
                <h3>Facebook</h3>
                <ul class="viavaex-list||CLASS||">
                    <li>
                        <a class="vv-link" href="||LINK1||" title="" target="_blank">
                            <div class="uk-grid-small" uk-grid>
                                <div class="uk-width-3-4@m">
                                    <div class="content">
                                        <span class="date">||DATE1||</span>
                                        <span class="title">||MESSAGE1||</span>
                                        <span class="link">||LEESMEER1||</span>
                                    </div>
                                </div>
                                <div class="uk-width-1-4@m">
                                    <div class="auto-thumbnail" style="background-image: url('||PICTURE1||');"></div>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <div class="block uk-height-1-1">
                ||STOCKBLOCK||
            </div>
        </div>
    </div>
</div>
</li>`
    import InfiniteLoading from 'vue-infinite-loading'
    import stockItem from './_item.vue'
    import vSelect from 'vue-select'
    import _ from 'lodash'

    const api = '/get/stock'
    const apiCount = '/get/countstock'

    export default {
        data () {
            return {
                list: [],
                countList: [],
                selectList: [],
                selectedType: 0,
                subdirectory: '',
                translations: {},
                term: '',
                state: '',
                showh2: false,
                favorites: ''
            }
        },
        created: function () {
            this.setCount()
            this.translations = this.$root.translations
            if (this.$root.subdirectory !== '') {
                this.subdirectory = '/' + this.$root.subdirectory
            }
            if (getQueryString('term')) {
                this.term = getQueryString('term')
            }
            if (getQueryString('favorites')) {
                this.selectedType = 0;
                this.favorites = this.$ls.get('favorites')
            }
            if (getQueryString('voertuigsoort')) {
                this.selectedType = getQueryString('voertuigsoort')
            } else if (this.$root.category) {
                this.selectedType = this.$root.category
            }
        },
        methods: {
            onInfinite (state) {
                this.state = state
                this.$axios.get(api + '?offset=' + this.list.length + '&voertuigsoort=' + this.selectedType + '&term=' + this.term + '&favorites=' + this.favorites)
                    .then((res) => {
                        if (res.data.length) {
                            this.list = this.list.concat(res.data)
                            state.loaded();
                            (this.list.length > 7) && this.appendBlock()
                        } else {
                            state.complete()
                        }
                    })
            },
            changeFilter () {
                this.removeBlock('blocks')
                this.list = []
                this.$nextTick(() => {
                    this.state.reset()
                })
            },
            resetFilter () {
                this.favorites = ''
                this.selectedType = 0
                this.term = ''
                this.$nextTick(() => {
                    this.changeFilter()
                })
            },
            setCount () {
                this.$axios.get(apiCount).then((res) => {
                    this.countList = res.data
                    this.selectList = _.values(this.$root.translations.choices)
                })
            },
            setSelect (value) {
                this.removeBlock('blocks')
                this.term = ''
                this.favorites = ''
                this.selectedType = value
                this.changeFilter()
            },
            removeBlock (id) {
                var elem = document.getElementById(id)
                if (document.getElementById('blocks')) {
                    return elem.parentNode.removeChild(elem)
                }
            },
            appendBlock () {
                if (!document.getElementById('blocks') && this.$root.facebook) {
                    let fb = this.$root.facebook
                    let bl = blocks
                        .replace('||CLASS||', fb.full_picture ? '' : ' no-picture')
                        .replace('||DATE1||', fb.created_time)
                        .replace('||LINK1||', fb.permalink_url)
                        .replace('||PICTURE1||', fb.full_picture)
                        .replace('||MESSAGE1||', fb.message ? fb.message.substring(0, 75) + '...' : '')
                        .replace('||LEESMEER1||', this.$root.translations.Lees_meer)
                        .replace('||STOCKBLOCK||', this.$root.stockblock)


                    $(document.getElementById('stocklist')).find('> li:nth-child(8)').after(bl)
                }
            }
        },
        components: {
            vSelect,
            InfiniteLoading,
            stockItem
        }
    }

</script>